import "@esri/calcite-components/components/calcite-list";
import "@esri/calcite-components/components/calcite-loader";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import { useEffect, useState } from "react";

import texts from "../../assets/texts/texts";
import "@esri/calcite-components/components/calcite-tooltip";

function ViewPoints() {
  const [viewPoints, setViewPoints] = useState(undefined);
  const [viewload, setViewload] = useState(false);
  const scenView = document.querySelector("#viewDiv");
  useEffect(() => {
    scenView.view.when(() => {
      setViewload(true);
    });

    if (viewload) {
      const viewPoint = new FeatureLayer({
        url: "https://gis.brno.cz/ags1/rest/services/Hosted/KAM_Vyhlidkove_Mista_WFL1/FeatureServer/0",
        visible: false,
        listMode: "hide",
      });

      let query = viewPoint.createQuery();
      query.where = "1=1";
      query.returnGeometry = true;
      viewPoint.queryFeatures(query).then(function (response) {
        const atributsValue = response.features.map(
          (value) => value.attributes,
        );

        const filteredAttributs = atributsValue.filter(
          (value) =>
            value.nazev !== "Myslivna v Kohoutovicích" &&
            value.nazev !== "Vyhlídka Mahenova stráň (Červený kopec)",
        );
        setViewPoints(filteredAttributs);
      });
    }
  }, [viewload]);

  const changeCameraPosition = (responseAttributes) => {
    var latitude = responseAttributes.latitude;
    var longitude = responseAttributes.longitude;
    var zValue = responseAttributes.z;
    var tilt = responseAttributes.till;
    var heading = responseAttributes.heading;

    const cam = scenView.camera.clone();
    cam.heading = heading;
    cam.tilt = tilt;
    cam.fow = 55;
    cam.position.latitude = latitude;
    cam.position.longitude = longitude;
    cam.position.z = zValue;

    scenView.view.goTo(cam);
  };
  return (
    <>
      {viewPoints && (
        <>
          <calcite-list label="Park features" drag-enabled>
            {viewPoints.map((item, index) => (
              <span key={"viewpoints_" + index}>
                <calcite-list-item label={item.name}>
                  <calcite-action
                    onClick={() => {
                      changeCameraPosition(item);
                    }}
                    slot="actions-end"
                    icon="zoom-to-object"
                    id={removeDiacriticsAndSpecialCharacters(item.name)}
                  ></calcite-action>
                </calcite-list-item>
                <calcite-tooltip
                  reference-element={removeDiacriticsAndSpecialCharacters(
                    item.name,
                  )}
                  placement="left"
                >
                  <span>
                    {texts.widgets.viewpoints.zomin + ": " + item.name}
                  </span>
                </calcite-tooltip>
              </span>
            ))}
          </calcite-list>
        </>
      )}
    </>
  );
}

export default ViewPoints;

function removeDiacriticsAndSpecialCharacters(str) {
  if (str) {
    // Remove diacritics by converting accented characters to their base form
    const normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Remove all non-alphanumeric characters
    const cleanedStr = normalizedStr.replace(/[^a-zA-Z0-9]/g, "");

    // Resource to lowercase
    return cleanedStr.toLowerCase();
  }
}
